import React, { useState } from 'react';

import { ButtonMantine, Center, Flex, Image, Skeleton, Stack, Text } from 'ui';
import { CollapsibleCard } from 'ui/Core';

import { useShowCause } from '../../../api';
import { Constants } from '../../../config/constants';
import { useBreakPoints, usePlatformService } from '../../../hooks';
import { BrowserSupportModal } from '../../Modals';

const BodyContent = () => {
  const { isDesktop } = useBreakPoints();

  if (isDesktop)
    return (
      <Text fz={12}>
        The Givebacks Genie is a chrome extension that will automatically fire when you visit a
        Givebacks eligible website so you can earn cash back when you shop online.
      </Text>
    );
  return (
    <Stack gap={4} fz="xs">
      <Text>Find participating local shops & restaurants.</Text>
      <Text lh="15px">
        Enroll in the Givebacks Online shopping program and earn when you shop at 25,000+ retailers.
      </Text>
      <Text>Track your impact and refer your friend.</Text>
    </Stack>
  );
};

const GetAppExtensionBody = ({
  skipComponent,
  causeId,
}: {
  skipComponent?: React.ReactNode;
  causeId?: string;
}) => {
  const Platform = usePlatformService();
  const { isDesktop } = useBreakPoints();

  const [showBrowserSupportModal, setShowBrowserSupportModal] = useState(false);
  const { data: cause } = useShowCause(causeId);

  const handleGetApp = () => {
    if (Platform.mobileBrowser) {
      if (Platform.mobileBrowser == 'ios') {
        window.location.href = Constants.AppLinks.appStore;
      } else {
        window.location.href = Constants.AppLinks.android_play_store;
      }
    } else {
      if (Platform.OS !== 'chrome') {
        setShowBrowserSupportModal(true);
      } else window.location.href = Constants.chromeWebsStore;
    }
  };
  return (
    <Stack gap="lg" px={0} mt={{ base: 'md', sm: 'lg' }}>
      <Flex direction={isDesktop ? 'row' : 'column'} gap={isDesktop ? 'lg' : 'md'}>
        <Stack>
          <Stack gap={4}>
            <Text fz={18} fw={600}>
              {isDesktop ? 'Get the Extension' : 'Get the Givebacks App'}
            </Text>
            <Text fz="sm" fw={500}>
              {isDesktop
                ? 'Never miss out on Givebacks with the Genie!'
                : `You can earn up to 5x for ${cause?.name} with the app!`}
            </Text>
          </Stack>

          <BodyContent />
        </Stack>
        <Center style={{ flexShrink: 0 }}>
          <Image
            src={
              Platform.isDesktopBrowser
                ? 'https://s3.amazonaws.com/com.givebacks.public/images/donations/desktop-offer.png'
                : 'https://s3.amazonaws.com/com.givebacks.public/images/donations/phone-with-map.png'
            }
            style={{ width: 250, height: 'auto' }}
          />
        </Center>
      </Flex>

      <ButtonMantine variant="gradient" fullWidth onClick={handleGetApp}>
        {isDesktop ? 'Get the Extension' : 'Get the App'}
      </ButtonMantine>
      <BrowserSupportModal
        opened={showBrowserSupportModal}
        onClose={() => setShowBrowserSupportModal(false)}
      />
      {skipComponent}
    </Stack>
  );
};

type Props = {
  causeId?: string;
  isCardExpanded: boolean;
  skipComponent?: React.ReactNode;
};

export const GetAppExtensionCard = ({ causeId, isCardExpanded, skipComponent }: Props) => {
  const { data: cause, isLoading } = useShowCause(causeId);

  return (
    <CollapsibleCard
      isCardExpanded={isCardExpanded}
      headerElement={
        <CollapsibleCard.Header
          imageUrl={cause?.thumbnail?.url}
          title={
            <Text fz={18} fw={600} c="white">
              You are supporting{' '}
              <Skeleton visible={isLoading} w={50}>
                <Text c="tangerine" style={{ display: 'inline' }}>
                  {cause?.name}
                </Text>
              </Skeleton>{' '}
              on Givebacks
            </Text>
          }
        />
      }
    >
      <GetAppExtensionBody skipComponent={skipComponent} causeId={causeId} />
    </CollapsibleCard>
  );
};
